import {Plan} from '../types/Plan';
import {Col, Container, Row} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faArrowUpRightFromSquare} from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import {Tree} from './Tree';

interface TreeviewProps {
    data: Plan[];
    skutecnost: boolean;
    setSelected: (Plan: Plan) => void;
    idPlan: number | undefined;
}

export const TreeView: React.FC<TreeviewProps> = ({data, skutecnost, setSelected, idPlan}) => {
    return (
        <Container style={{margin: 0}}>
            <Row>
                <Col className="class-col smaller-text">Částky uváděné v tis. Kč</Col>
            </Row>
            <Row className="main-container class-row-font" style={{backgroundColor: 'rgb(65,118,204)', margin: 0}}>
                <Col xs={7} style={{color: 'white'}}>
                    {'NÁZEV'}
                </Col>
                <Col className="class-col" style={{color: 'white'}}>
                    {skutecnost ? 'UPRAV. ROZPOČET' : 'SCHVÁL. ROZPOČET'}
                </Col>
                <Col className="class-col" style={{color: 'white'}}>
                    {skutecnost ? 'SKUTEČNOST' : 'UPRAV. ROZPOČET'}
                </Col>
            </Row>
            <Tree data={data} skutecnost={skutecnost} setSelected={setSelected} idPlan={idPlan} />
        </Container>
    );
};
